import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

const meta = {
  permissions: ['administrator'],
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/forms'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'forms_wrapper',
          meta,
          redirect: to => {
            return { name: 'forms_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'forms_list',
          meta,
          component: Index,
        },
      ],
    },
  ],
};
